import React from 'react'
import { useSelector } from 'react-redux'
import { selectBridgedWidgets } from 'ducks/widgets/selectors'

import EmptyPage from './EmptyPage'
import ErrorContent from '../ErrorContent'

const ErrorPage = () => {
  const isEmpty = useSelector(selectBridgedWidgets).length === 0
  return (
    <ErrorContent
      isEmpty={isEmpty}
      EmptyComponent={EmptyPage}
      globalNavActive="Social Chat"
    />
  )
}

export default ErrorPage
